export default class PenaltyCharge {
    constructor({
        id = null,
        penaltyChargeRate = null,
        statusId = null,
        name = '',
        itemOrder = 0,
        createdAt = new Date(),
        updatedAt = new Date()
    }) {
        this.id = id;
        this.penaltyChargeRate = penaltyChargeRate;
        this.statusId = statusId;
        this.name = name;
        this.itemOrder = itemOrder;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
    }
}